'use client';

import { globalStyles } from '../styles/makeStyles';
import { ThemeProvider } from '@mui/material';

export default function ThemeNextProvider({ children }: { children: React.ReactNode }) {
  return <ThemeProvider theme={globalStyles}>{children}</ThemeProvider>;
}
